export const buildSectionHeaderRegistry = (data): { [key: string]: Object } => {
  return data.reduce((allSections, item) => {
    if (!!item.data) {
      const areaSections = item.data['section'] || [];
      return {
        ...allSections,
        ...areaSections.reduce(
          (all, section) => ({
            ...all,
            [section.name]: section.data,
          }),
          {},
        ),
      };
    } else {
      return allSections;
    }
  }, {});
};
